import { webApi } from '@mi-front/api-clients';
import { DateTime } from 'luxon';
import { useMemo } from 'react';
import { RECENT_BROADCASTS_HOURS } from '../shared/consts';

const BROADCASTS_QUERY_OPTIONS = {
  staleTime: Infinity,
  refetchOnWindowFocus: false,
  refetchOnMount: false,
  refetchOnReconnect: false,
} as const;

/**
 * Builds ISO from/to range for recent YouTube broadcasts queries.
 * `to` is clamped to the start of the current hour so the query key stays stable
 * across Suspense remounts within the same hour.
 */
export function getRecentBroadcastsQueryParams(now = DateTime.now()) {
  const to = now.startOf('hour');

  return {
    from: to.minus({ hours: RECENT_BROADCASTS_HOURS }).toISO()!,
    to: to.toISO()!,
  };
}

/** Fetches recent YouTube broadcasts for the last 24 hours; suspends until data is ready. */
export function useYoutubeRecentBroadcasts(stationId: string) {
  const params = useMemo(() => getRecentBroadcastsQueryParams(DateTime.now()), []);

  return webApi.useGetYoutubeIntegrationBroadcastsBroadcastsSuspense(stationId, params, {
    query: BROADCASTS_QUERY_OPTIONS,
  });
}

/** Non-suspense variant for components that manage their own loading UI. */
export function useYoutubeRecentBroadcastsQuery(stationId: string) {
  const params = useMemo(() => getRecentBroadcastsQueryParams(DateTime.now()), []);

  return webApi.useGetYoutubeIntegrationBroadcastsBroadcasts(stationId, params, {
    query: BROADCASTS_QUERY_OPTIONS,
  });
}
